"use client";
import {
  StripeCardForm,
  StripeCardFormInnerProps,
} from "@/features/stripe/components/StripeCardForm";
import { StripeInitError } from "@/features/stripe/components/StripeInitError";
import { StaffCardSavedView } from "./StaffCardSavedView";
import { StripeState } from "@/features/stripe/types";
import { useCardCaptureAnalytics } from "@/features/card-capture/hooks/useCardCaptureAnalytics";

interface CardCapturePanelProps {
  onSuccess: StripeCardFormInnerProps["onSuccess"];
  onRetry: VoidFunction;
  stripeState: StripeState;
  patientId: string;
}

export function StaffCardCapturePanel({
  onSuccess,
  onRetry,
  stripeState,
  patientId,
}: CardCapturePanelProps) {
  const cardCaptureHandlers = useCardCaptureAnalytics(
    "Staff",
    patientId,
    onSuccess,
  );

  if (stripeState.phase === "ready") {
    return (
      <StripeCardForm
        stripePromise={stripeState.stripePromise}
        clientSecret={stripeState.clientSecret}
        {...cardCaptureHandlers}
        consent={{
          type: "checkbox",
        }}
        cardholderInputProps={{
          placeholder: "Michael Thompson",
        }}
      />
    );
  }

  if (stripeState.phase === "error") {
    return <StripeInitError message={stripeState.message} onRetry={onRetry} />;
  }

  if (stripeState.phase === "success") {
    return <StaffCardSavedView />;
  }

  return null;
}
